import { render, staticRenderFns } from "./skillorder.vue?vue&type=template&id=1d004ce2&"
import script from "./skillorder.vue?vue&type=script&lang=js&"
export * from "./skillorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports